module.exports = __webpack_public_path__ + "img/venta.bf4e8bb6.jpg";